export enum HubMethods {
    OnItem = 'onItem',
}
